// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-7d10b8d9]{max-width:600px}.videoWrapper[data-v-7d10b8d9]{grid-gap:15px;gap:15px;margin-top:10px}.video[data-v-7d10b8d9],.videoWrapper[data-v-7d10b8d9]{display:flex;flex-direction:column}.video[data-v-7d10b8d9]{grid-gap:10px;gap:10px}.icon-wrapper[data-v-7d10b8d9]{text-align:right}.icon[data-v-7d10b8d9]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
